import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import App from '~/App';
import { getLogger } from '~/utils/logger';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  renderType: 'render',
  loadRootComponent: () => {
    return new Promise<React.FunctionComponent>((resolve) => {
      if (process.env.USE_MSW_MOCK === 'true') {
        import('./mocks/browser').then(({ worker }) => {
          worker.start({
            onUnhandledRequest: 'bypass',
          });
          resolve(App as React.FunctionComponent);
        });
      } else {
        resolve(App as React.FunctionComponent);
      }
    });
  },
  errorBoundary(err: any, info: any, props: any) {
    getLogger().error(`[singleSpaReact] - ${err}`, { info, props });
    throw err;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
